<template>
  <div id="workbench">
    <div class="ipub-h1 mar-b-20 relative">
      Reviews
    </div>
    <ipub-row :gutter="[12, 16]">
      <!-- <ipub-col :span="3">
        <ipub-select v-model="params.journalId"
                     placeholder="Select Journal"
                     @change="changeJournal"
                     :options="journalList" />
      </ipub-col> -->
      <ipub-col :span="12">
        <site-search-group v-model.trim="params.keyword"
                           placeholder="Enter Manuscript Title | Manuscript ID"
                           @search="getList()"
                           @clear="handleClear" />
      </ipub-col>
    </ipub-row>

    <div class="ipub-p1 mar-b-20 ipub-list-tab">
      <a v-for="(val, key) in countStatus"
         :key="key"
         @click="changeStatus(key)"
         :class="['ipub-list-tab--status', params.invitationStatus === key ?'active':'']">{{titleStatus[key]}} ({{val||0}})</a>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns[params.invitationStatus]"
                  :empty="{icon:'icona-reviewreport'}"
                  :emptyText="emptyText[params.invitationStatus]"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:manuscriptNo="{record}">
          <div class="table-manuscriptNo-slot">
            <span class="ipub-p2">{{record.code}}</span>
            <ipub-label class="mar-l-10"
                        size="small"
                        type="warning"
                        cover>V{{record.sign}}</ipub-label>
            <!-- <span class="common-tag table-manuscriptNo-slot-span ipub-p2 fw-bd mar-l-10"></span> -->
          </div>
        </template>
        <template v-slot:time="{record}">
          <div v-if="record.reviewDueTime">
            <div v-if="params.invitationStatus === 'ACCEPT_INVITATIONS'"
                 :class="$moment(record.reviewDueTime).diff($moment(), 'days')<0?'key-color':$moment(record.reviewDueTime).diff($moment(), 'days')<6?'warning-color':''">
              <template v-if="!['COMPLETED'].includes(record.status)">
                <div class="ipub-p2 fw-bd"
                     v-if="$moment(record.reviewDueTime).diff($moment(), 'days')>0">{{$moment(record.reviewDueTime).diff($moment(), 'days')}} Days left</div>
                <div class="ipub-p2 fw-bd"
                     v-else>{{$moment().diff($moment(record.reviewDueTime), 'days')}} Days Over Due</div>
              </template>
              <div class="ipub-p2 fw-bd">{{$moment(record.reviewDueTime).format('DD / MM / YYYY')}}</div>
            </div>
            <div v-else
                 class="ipub-p2 fw-bd">{{$moment(record.reviewDueTime).format('DD / MM / YYYY')}}</div>
          </div>
          <template v-else>- -</template>
        </template>
        <template v-slot:img="{record}">
          <div>
            <img :src="`${domain}/${record.journal.cover}`"
                 style="width:41px;height:58px"
                 alt="">
          </div>
        </template>
        <template v-slot:status="{record}">
          <div :class="(['NO_RESPONSE','AGREED'].includes(record.status) && $moment(record.reviewDueTime).diff($moment(), 'days')<0)?'key-color':(['NO_RESPONSE','AGREED'].includes(record.status) && $moment(record.reviewDueTime).diff($moment(), 'days')<6)?'warning-color':''">
            <p class="ipub-p2 fw-bd">{{reviewerStatus[record.status]}}</p>
            <span>{{$moment(record.statusTime).format('DD / MM / YYYY')}}</span>
          </div>
        </template>
        <template v-slot:editor="{text}">
          <div v-if="text"
               class="ipub-p2">
            {{text.firstName}} {{text.lastName}}
          </div>
          <div v-else>--</div>
        </template>
        <!-- 状态：
        NoResponse：接受、拒绝
        Late：申请延时
        Agreed：提交决策
        completed：决策详情
        Decline，Terminated v-else：摘要

         -->
        <template v-slot:actions="{ record }">
          <ipub-tooltip v-show="!['COMPLETED'].includes(record.status)"
                        placement="bottomRight"
                        class="border-right">
            <div slot="title">
              Abstract
            </div>
            <ipub-icon @click="abstract(record)"
                       type="iconAbstract" />
          </ipub-tooltip>

          <template v-if="['COMPLETED'].includes(record.status)">
            <ipub-tooltip placement="bottomLeft">
              <div slot="title">
                Review Result
              </div>
              <ipub-icon @click="detail(record)"
                         type="iconViewDetails" />
            </ipub-tooltip>
            <!-- <ipub-tooltip placement="bottom">
              <div slot="title">
                <div class="mar-b-4 ipub-p2">
                  Download Certificate
                </div>
              </div>
              <ipub-icon type="iconCertificate"
                         @click="createCanvans(record, 'rc-c')"
                         class="ipub-c-p" />
            </ipub-tooltip> -->
          </template>

          <!-- 同意审稿 修改状态 v-if="['NO_RESPONSE'].includes(record.status)"-->
          <template v-if="['NO_RESPONSE'].includes(record.status)">
            <ipub-tooltip placement="bottomLeft">
              <div slot="title">
                Agree
              </div>
              <ipub-icon type="iconAble"
                         @click="able(record,'AGREED')" />
            </ipub-tooltip>
            <ipub-tooltip placement="bottomLeft">
              <div slot="title">
                Refuse
              </div>
              <ipub-icon type="iconDisable"
                         @click="unable(record)" />
            </ipub-tooltip>
          </template>

          <template v-if="params.invitationStatus !='COMPLETED_INVITATIONS'">
            <ipub-tooltip class="border-right"
                          v-show="$moment(record.reviewDueTime).diff($moment(), 'days')<0"
                          placement="bottomLeft">
              <div slot="title">
                Apply for Extension
              </div>
              <ipub-icon type="icona-ApplyforExtension"
                         @click="sendEmail(record)" />
            </ipub-tooltip>
          </template>

          <!-- 提交决策 -->
          <ipub-tooltip v-show="['AGREED'].includes(record.status)"
                        placement="bottomLeft">
            <div slot="title">
              Submit Decision
            </div>
            <ipub-icon type="icona-SpecialIssueEdit"
                       @click="commit(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <!-- 摘要 -->
    <abstract-modal :abstract="abstractDetail"
                    :isVisable="isVisable"
                    @cancel="cancel"></abstract-modal>
    <detailReport :isVisable="showDetail"
                  :inputData="inputData"
                  @cancel="cancel"></detailReport>
    <SendEmail :isVisable="showSendEmail"
               :inputData="inputData"
               event="REVIEWER_APPLY_FOR_DELAYING_SUBMISSION"
               @send="cancel"
               @cancel="cancel" />

    <CreatePNG :isVisable="isVisablePDF"
               :inputData="inputData"
               :type="pdfType"
               :edit="false"
               :journalId="inputData.journal && inputData.journal.id"
               @confirm="cancel"
               @cancel="cancel" />
  </div>

</template>


<script>
import main from './main'
export default main

</script>
<style lang="scss" scoped>
@import './main.scss';
</style>

